export default {
  data: {
    jobsForUser: {
      jobs: [
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323793741",
          job_url_direct: null,
          title: "Software Developer",
          company: "EchoDigiTech Ltd",
          location: "Bradford, Yorkshire and the Humber, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 39000.0,
          max_amount: 39000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "Job Summary: \\nWe are seeking a talented Software Engineer to join our dynamic team. The ideal candidate will be proficient in JavaScript, C++, SVN, MySQL, .NET, APIs, Ruby on Rails, AWS, Linux, and other relevant technologies. This is an exciting opportunity for a skilled individual to contribute to cutting-edge projects in a collaborative environment.\\n\\nDuties: \\n- Develop high-quality software design and architecture \\n- Identify, prioritise, and execute tasks in the software development life cycle \\n- Develop tools and applications by producing clean, efficient code \\n- Automate tasks through appropriate tools and scripting \\n- Review and debug code \\n- Perform validation and verification testing \\n- Collaborate with internal teams to fix and improve software\\n\\nExperience: \\n- Proven work experience as a Software Engineer or Software Developer \\n- Proficiency in JavaScript, C++, SVN, MySQL, .NET, APIs, Ruby on Rails, AWS, Linux, etc. \\n- Experience with software design and architecture \\n- Knowledge of coding languages (e.g., Java, Python) \\n- Ability to learn new languages and technologies \\n- Strong problem-solving skills \\n- BSc\\/MSc degree in Computer Science or related field\\n\\nJoin us in our innovative projects where you can showcase your skills and grow professionally as part of our dedicated team. Apply now for this exciting opportunity!\\n\\nJob Types: Full-time, Permanent, Graduate\\n\\nPay: Up to \\u00a339,000.00 per year\\n\\nEducation:\\n\\n* Bachelor's (preferred)\\n\\nWork Location: In person\\n\\nApplication deadline: 01\\/07\\/2024 \\nReference ID: EDT001 \\nExpected start date: 18\\/07\\/2024",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description:
            "Test company description for EchoDigiTech Ltd. This is a test description for the company.",
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 80,
          requirements: [
            "JavaScript",
            "C++",
            "SVN",
            "MySQL",
            ".NET",
            "APIs",
            "Ruby on Rails",
            "AWS",
            "Linux",
          ],
          status: "Interviewing",
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323206476",
          job_url_direct: null,
          title: "Mechanical Automation Engineer",
          company: "Valknut Automation Ltd",
          location: "United Kingdom",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 55000.0,
          max_amount: 65000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "The ideal candidate will have a strong background in mechanical engineering and a passion for automation technology. This role will involve implementing, building and aligning mechanical automated systems to streamline our clients processes and improve overall operational efficiency.\\n\\nMajor Responsibilities:\\n\\n- Mechanical systems build, including robotics, conveyors, and assembly lines.\\n\\n- Collaborate with cross-functional teams, including electrical engineers, software developers, and production managers, to integrate mechanical systems with other automation components.\\n\\n- Potential additional design and implementation of mechanical systems.\\n\\n- Troubleshoot and resolve technical issues related to automated systems\\n\\n- Oversee the installation, commissioning, and maintenance of automation equipment.\\n\\nPerson specification:\\n\\nThe ideal candidate will be able to demonstrate ability in:\\n\\n- Mechanical installation of mechanical tooling systems.\\n\\n- Alignment of large mechanical systems at the clients premises.\\n\\n- Mechanical design and implementation including some commissioning would be advantageous.\\n\\n- Ability to travel to customer sites including if necessary overnight stays is essential.\\n\\n- PLC Programming and Robot programming knowledge and\\/or qualifications would be advantageous but not essential.\\n\\n- Electrical knowledge would be advantageous.\\n\\nJob Type: Permanent\\n\\nPay: \\u00a355,000.00-\\u00a365,000.00 per year\\n\\nSchedule:\\n\\n* Monday to Friday\\n\\nWork Location: On the road\\n\\nExpected start date: 01\\/07\\/2024",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description:
            "The ideal candidate will have a strong background in mechanical engineering and a passion for automation technology. This role will involve implementing, building and aligning mechanical automated systems to streamline our clients processes and improve overall operational efficiency.\\n\\nMajor Responsibilities:\\n\\n- Mechanical systems build, including robotics, conveyors, and assembly lines.\\n\\n- Collaborate with cross-functional teams, including electrical engineers, software developers, and production managers, to integrate mechanical systems with other automation components.\\n\\n- Potential additional design and implementation of mechanical systems.\\n\\n- Troubleshoot and resolve technical issues related to automated systems\\n\\n- Oversee the installation, commissioning, and maintenance of automation equipment.\\n\\nPerson specification:\\n\\nThe ideal candidate will be able to demonstrate ability in:\\n\\n- Mechanical installation of mechanical tooling systems.\\n\\n- Alignment of large mechanical systems at the clients premises.\\n\\n- Mechanical design and implementation including some commissioning would be advantageous.\\n\\n- Ability to travel to customer sites including if necessary overnight stays is essential.\\n\\n- PLC Programming and Robot programming knowledge and\\/or qualifications would be advantageous but not essential.\\n\\n- Electrical knowledge would be advantageous.\\n\\nJob Type: Permanent\\n\\nPay: \\u00a355,000.00-\\u00a365,000.00 per year\\n\\nSchedule:\\n\\n* Monday to Friday\\n\\nWork Location: On the road\\n\\nExpected start date: 01\\/07\\/2024",
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 60,
          requirements: ["Mechanical Engineering", "Automation Technology"],
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323471923",
          job_url_direct: null,
          title: "Process, Automation & Control Engineer (Trainee)",
          company: "Diversey, Inc.",
          location: "Bradford, Yorkshire and the Humber, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 29510.0,
          max_amount: 34350.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "Trainee Process Automation & Control Engineer\\nLocation \\u2013 Low Moor Bradford.\\nSolenis is a leading global producer of specialty chemicals focused on delivering sustainable solutions for water-intensive industries, including consumer, industrial, institutional, food and beverage, and pool and spa water markets. Owned by Platinum Equity, the company\\u2019s product portfolio includes a broad array of water treatment chemistries, process aids, functional additives, and cleaners and disinfectants, as well as state-of-the-art monitoring and control systems. These technologies are used by customers to improve operational efficiencies, enhance product quality, protect plant assets, minimize environmental impact, and create cleaner and safer environments.\\nHeadquartered in Wilmington, Delaware, the company has 69 manufacturing facilities strategically located around the globe and employs a team of over 16,100 professionals in 130 countries across six continents. Solenis is a 2024 US Best Managed Company, recognized three years in a row. For more information about Solenis, please visit www.solenis.com.\\nWe are thrilled to go to market for the search of our new Trainee Process Automation & Control Engineer to join us at our Bradford manufacturing plant. As a Trainee Process Automation & Control Engineer you will play an integral part in supporting and assisting in automation projects, maintenance, and operational support.\\nKey Responsibilities:* Support engineering projects related to automation systems, ensuring compliance with standards, safety, cost-efficiency, and quality.\\n* Assist in managing control system lifecycle including developing and implementing Emerson DeltaV control system configuration.\\n* Assist senior engineers to implement Operational Technology (OT) cybersecurity measures, ensuring adherence to the site\\u2019s cybersecurity management system and industry standards such as IEC62443 and HSE OG86.\\n* Manage and schedule maintenance visits for third-party contractors.\\n* Champion alarm management by acting as a point of contact for generating and analysing alarm KPIs, communicating findings, and assisting operations in complying with EEMUA191.\\n* Oversee Operational Technology antivirus measures, backups, and documentation maintenance.\\n* Collaborate with your manager to identify learning and development needs, attend training courses, complete self-learning packages, and progress into senior roles.\\n\\n\\nWhat you'll need to apply:\\nEssential:* A Degree\\/HND\\/HNC in Automation, Control Engineering, Electrical Engineering, or a related field.\\n* Basic understanding of Distributed Control Systems and OT Cyber Security\\n* Strong problem-solving skills and the ability to analyse complex technical issues.\\n* Ability to work collaboratively with senior engineers, production teams, and third-party contractors.\\n* Strong organisational and time-management skills, with the ability to manage multiple tasks and projects simultaneously.\\n* Excellent verbal and written communication skills, with the ability to effectively convey technical information to non-technical stakeholders.\\n* High level of accuracy and attention to detail in all aspects of work.\\n* Proficiency in using standard Microsoft office software (Outlook, Excel, Word, PowerPoint).\\n\\n\\nDesired:* Previous experience working in the chemical industry or a related field.\\n* Familiarity with Emerson DeltaV Control Systems or PLC\\/SCADA systems.\\n* Experience diagnosing and resolving issues with Windows PCs.\\n\\n\\nThe Benefits:* An attractive salary.\\n* An annual bonus scheme.\\n* A company enhanced pension scheme.\\n* Life Assurance.\\n* Private healthcare.\\n* On-site gym with an instructor.\\n* Multi-faith rooms.\\n* Employee assistance program.\\n* Cycle to work scheme.\\n* On-site sports and social club.\\n* Free on-site parking (some bays with electric vehicle charging stations).\\n\\n\\nWe understand that candidates will not meet every single desired qualification. If your experience looks a little different from what we have identified and you think you can bring value to the role, we would love to learn more about you.\\nAt Solenis, we understand that our greatest asset is our people. That is why we offer competitive compensation, comprehensive benefits, and numerous opportunities for professional growth and development. So, if you are interested in working for a world-class company and enjoy solving complex challenges, consider joining our team.\\nSolenis is proud to be an Equal Opportunity Affirmative Action Employer. All qualified applicants will receive consideration for employment without regard to age, race, color, religion, sex, sexual orientation, gender identity, national origin, and will not be discriminated against because of disability.",
          company_url: "https://www.glassdoor.co.uk/Overview/W-EI_IE1844572.htm",
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 25,
          requirements: [
            "Automation Systems",
            "Emerson DeltaV Control System Configuration",
            "Operational Technology (OT) Cybersecurity",
            "IEC62443",
            "HSE OG86",
            "Alarm Management",
            "EEMUA191",
          ],
        },
        // Additional jobs start here
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323793742",
          job_url_direct: null,
          title: "Data Analyst",
          company: "TechSolutions Ltd",
          location: "London, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 45000.0,
          max_amount: 55000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "We are looking for a detail-oriented Data Analyst to join our team. The ideal candidate will have strong analytical skills and proficiency in SQL, Python, and data visualization tools. This role involves analyzing large datasets, creating reports, and providing actionable insights to improve business processes and decision-making.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 70,
          requirements: ["SQL", "Python", "Data Visualization Tools"],
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323206477",
          job_url_direct: null,
          title: "Marketing Manager",
          company: "Global Marketing Agency",
          location: "Manchester, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 50000.0,
          max_amount: 70000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "We are seeking a dynamic Marketing Manager to lead our marketing team. Responsibilities include developing and implementing marketing strategies, managing campaigns, and analyzing market trends. The ideal candidate will have proven experience in digital marketing, strong leadership skills, and a passion for driving business growth.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 85,
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323471924",
          job_url_direct: null,
          title: "Financial Analyst",
          company: "Finance Plus Ltd",
          location: "Edinburgh, Scotland",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 48000.0,
          max_amount: 60000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "Finance Plus Ltd is hiring a Financial Analyst to join our finance team. This role involves financial modeling, forecasting, and analysis to support strategic decision-making. The ideal candidate will have strong quantitative skills, experience in financial planning, and proficiency in Excel and financial software.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 75,
        },
        // Additional jobs can continue here...
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323793743",
          job_url_direct: null,
          title: "Product Manager",
          company: "Tech Innovations Ltd",
          location: "Cambridge, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 60000.0,
          max_amount: 80000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "Tech Innovations Ltd is looking for a talented Product Manager to drive our product roadmap and strategy. This role involves defining product features, conducting market research, and collaborating with engineering and marketing teams to launch successful products.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 90,
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323206478",
          job_url_direct: null,
          title: "Human Resources Manager",
          company: "PeopleFirst HR",
          location: "Birmingham, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 55000.0,
          max_amount: 70000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "PeopleFirst HR is seeking an experienced Human Resources Manager to oversee our HR department. Responsibilities include employee relations, recruitment, training, and policy implementation. The ideal candidate will have strong HR management skills and a strategic approach to HR initiatives.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 80,
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323471925",
          job_url_direct: null,
          title: "UX/UI Designer",
          company: "DigitalDesigns Ltd",
          location: "London, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 50000.0,
          max_amount: 65000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "DigitalDesigns Ltd is looking for a talented UX/UI Designer to create amazing user experiences. The ideal candidate will have a strong portfolio of successful UX and UI design projects, proficiency in design tools, and a passion for creating intuitive interfaces.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 70,
        },
        // Additional jobs can continue here...
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323793744",
          job_url_direct: null,
          title: "Sales Manager",
          company: "SalesPro Ltd",
          location: "Manchester, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 60000.0,
          max_amount: 80000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "SalesPro Ltd is hiring a Sales Manager to lead our sales team. Responsibilities include setting sales goals, developing strategies to achieve them, and overseeing the sales process. The ideal candidate will have proven sales management experience and a track record of driving revenue growth.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 85,
        },
        {
          id: "666db03c604d4cab210ce7f1",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323206479",
          job_url_direct: null,
          title: "Content Writer",
          company: "ContentCreators Ltd",
          location: "Edinburgh, Scotland",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 40000.0,
          max_amount: 50000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "ContentCreators Ltd is seeking a talented Content Writer to join our team. The ideal candidate will have strong writing skills, experience in creating content for digital platforms, and the ability to adapt writing style based on target audience and brand voice.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 75,
        },
        {
          id: "1009323471926",
          site: "glassdoor",
          job_url: "https://www.glassdoor.co.uk/job-listing/j?jl=1009323471926",
          job_url_direct: null,
          title: "Network Engineer",
          company: "TechNet Ltd",
          location: "Bristol, England",
          job_type: null,
          date_posted: 1718323200000,
          interval: "yearly",
          min_amount: 55000.0,
          max_amount: 70000.0,
          currency: "GBP",
          is_remote: false,
          job_function: null,
          emails: null,
          description:
            "TechNet Ltd is looking for a skilled Network Engineer to join our IT team. The ideal candidate will have experience in network infrastructure, security protocols, and troubleshooting. Responsibilities include designing and implementing network solutions to support business operations.",
          company_url: null,
          company_url_direct: null,
          company_addresses: null,
          company_industry: null,
          company_num_employees: null,
          company_revenue: null,
          company_description: null,
          logo_photo_url: null,
          banner_photo_url: null,
          ceo_name: null,
          ceo_photo_url: null,
          match: 80,
        },
      ],
      message: "Found 15 jobs",
    },
  },
};
